import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";
import { LANGUAGES } from "@/lib/i18n";

export default function Languages() {
  return (
    <>
      <PageHero
        eyebrow="Languages"
        title="Read Anant Jeevan in your language."
        subtitle="We are translating articles with theological review into Hindi and several Indian languages. Where a translation is not yet available, we will show you the English or Hindi version."
      />
      <section className="py-16 sm:py-24">
        <div className="container-editorial grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {LANGUAGES.map((l) => (
            <div key={l.code} className="paper-card p-6 text-center">
              <p className="font-serif text-2xl text-ink" style={{ fontWeight: 500 }}>{l.nativeLabel}</p>
              <p className="eyebrow mt-2">{l.label}</p>
              <p className="text-xs text-ink-muted mt-3">
                {l.code === "en" ? "Available" : "In translation"}
              </p>
            </div>
          ))}
        </div>
        <div className="container-editorial mt-16 border-l-4 border-gold pl-8 py-6">
          <h3 className="heading-3">Translation workflow</h3>
          <p className="body-copy mt-4 text-ink-muted max-w-2xl">
            Draft → Language review → Theological review → Proofreading → Publish. We do not publish unreviewed
            machine translations as theological content.
          </p>
          <div className="mt-6">
            <Link to="/legal/translation-standards" className="btn-ghost">Read our translation standards</Link>
          </div>
        </div>
      </section>
    </>
  );
}
